import { render, staticRenderFns } from "./SuccessDetail.vue?vue&type=template&id=6cbc2555&"
import script from "./SuccessDetail.vue?vue&type=script&lang=js&"
export * from "./SuccessDetail.vue?vue&type=script&lang=js&"
import style0 from "./SuccessDetail.vue?vue&type=style&index=0&id=6cbc2555&prod&lang=css&"
import style1 from "./SuccessDetail.vue?vue&type=style&index=1&id=6cbc2555&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports